import { useModal } from '@flecto/ui'

import {
  ModalBookingSendEmail,
  type ModalBookingSendEmailProps,
} from '../components/ModalBookingSendEmail/ModalBookingSendEmail'

export function useModalBookingSendEmail(options?: ModalBookingSendEmailProps) {
  return useModal<ModalBookingSendEmailProps>({
    modalComponent: (props) => <ModalBookingSendEmail {...options} {...props} />,
  })
}
